import PlanChange from "../PlanChange";
import Model from "../Model";
import AssetConversion, {AssetConversionType} from "../AssetConversion";
import ModelStore from "../../stores/ModelStore";
import {CreateAssetConversionInput, UpdateAssetConversionInput} from "../../API";

export interface IQCDStrategyChange {
  conversions: AssetConversion[]
}

class QCDStrategyChange extends PlanChange implements IQCDStrategyChange {
  conversions: AssetConversion[]

  constructor (data: any) {
    super(data)
    this.conversions = this.details ? JSON.parse(this.details) : []
  }

  apply(model: Model) {
    this.conversions.forEach((c: AssetConversion) => {
      // Look for existing conversion
      const found = model.assetConversions.find((a: AssetConversion) =>
        a.conversionType === AssetConversionType.QCD && a.srcAssetId === c.srcAssetId && a.year === c.year)
      if (!found) {
        if (!c.srcAsset) {
          c.srcAsset = model.getAssetById(c.srcAssetId)
        }
        model.assetConversions.push(c)
        model.addLock(c.id, "*", "Locked by QCD Strategy")
      } else if (!found.completedAt) {
        // Override existing conversion
        found.amount = c.amount
        found.percent = c.percent
        model.addLock(found.id, "*", "Locked by QCD Strategy")
      }
    })
  }

  async commit(model: Model, modelStore: ModelStore) {
    const promises: Promise<AssetConversion | undefined>[] = []
    this.conversions.forEach((c: AssetConversion) => {
      // Look for existing conversion
      const found = model.assetConversions.find((a: AssetConversion) => a.id === c.id)
      if (!found || !found.updatedAt) {
        const input: CreateAssetConversionInput = {
          id: c.id,
          userId: model.userId,
          accountId: model.accountId,
          modelId: model.id,
          description: c.description,
          conversionType: c.conversionType,
          srcAssetId: c.srcAssetId,
          dstAssetId: "",
          year: c.year,
          amount: c.amount,
          percent: c.percent,
          taxableAmount: c.taxableAmount,
          incomeType: c.incomeType,
          sortOrder: model.assetConversions.length > 0 ? model.assetConversions[model.assetConversions.length-1].sortOrder + ModelStore.orderInterval : 0
        }
        promises.push(modelStore.createAssetConversion(input))
        model.deleteLock(c.id, "*")
      } else if (found) {
        // Update existing amount & percent
        const input: UpdateAssetConversionInput = {
          id: c.id,
          amount: c.amount,
          percent: c.percent
        }
        promises.push(modelStore.updateAssetConversion(input))
      }
    })

    await Promise.all(promises)
  }
}

export default QCDStrategyChange